import axios, { AxiosError, AxiosResponse } from 'axios';

let isLoggingOut = false;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config: any) => {
    if (localStorage.getItem('sessionExpired') === 'true' || isLoggingOut) {
      return Promise.reject(new Error('Session expired'));
    }
    
    let token = localStorage.getItem('access_token') || '';
    config.headers['Authorization'] = `Bearer ${token}`;
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.setItem('sessionExpired', 'true');
      window.location.replace(process.env.REACT_APP_LOGOUT_URL as string);
      return; 
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
